import { createAction } from '@reduxjs/toolkit';
import uniqueId from 'lodash-es/uniqueId';

import { Notification, NotificationType } from 'types/notification';

import { NOTIFICATION_DURATION_TIME } from './constants';

export const notificationAppeared = createAction<
  Notification & { timeout?: Nullable<number> }
>('notification appeared');
export const notificationDisappeared = createAction<Notification['id']>(
  'notification disappeared',
);
const getParams = ({
  id = uniqueId('system_notification_'),
  timeout = NOTIFICATION_DURATION_TIME,
  withTranslation = false,
  translationOptions = {},
}: NotificationParams = {}) => ({
  id,
  timeout,
  withTranslation,
  translationOptions,
});

type NotificationParams = Omit<Notification, 'id' | 'type' | 'message'> & {
  id?: string;
  timeout?: Nullable<number>;
};

export const hide = notificationDisappeared;

export const success = (message: string, params?: NotificationParams) =>
  notificationAppeared({
    message,
    type: NotificationType.Success,
    ...getParams(params),
  });
export const error = (message: string, params?: NotificationParams) =>
  notificationAppeared({
    message,
    type: NotificationType.Error,
    ...getParams(params),
  });
export const warning = (message: string, params?: NotificationParams) =>
  notificationAppeared({
    message,
    type: NotificationType.Warning,
    ...getParams(params),
  });
export const info = (message: string, params?: NotificationParams) =>
  notificationAppeared({
    message,
    type: NotificationType.Info,
    ...getParams(params),
  });
